<template>
  <div class="validation container fluid">
    <div class="validation__nav row">
      <Logo class="validation__nav__logo" color />
    </div>
    <div class="validation-layout row">
      <BasketReassurance />
      <div class="validation__content col-xs-11 col-md-8">
        <img src="@/assets/images/picto-undraw-4.svg" />
        <h2>
          Félicitations {{ user.surname }},<br />
          votre commande est validé !
        </h2>
        <p>
          Votre commande a été validé, vous recevrez votre paire
          <strong>dans 5 à 10 jours</strong>.
        </p>
        <p>
          Nous vous contacterons par email et/ou par téléphone pour vous tenir
          informé.
        </p>
        <a href="https://instagram.com/sneakboxapp/">
          <Button secondary>Nous suivre sur Instagram</Button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Logo from "@/components/Common/Logo";
import Button from "@/components/Common/Button";
import BasketReassurance from "@/components/Basket/BasketReassurance";
export default {
  name: "Validation",
  components: {
    Logo,
    Button,
    BasketReassurance
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  }
};
</script>

<style lang="scss">
.validation {
  &__nav {
    position: relative;
    justify-content: center;
    align-items: center;
    font-size: 1.6rem;
    padding: 2rem;
    img {
      height: 1.5rem;
      margin-right: 1rem;
    }
    &__back {
      position: absolute;
      left: 2rem;
    }
  }
  &-layout {
    text-align: center;
    justify-content: center;
    img {
      width: 50%;
      max-width: 50rem;
      margin: auto;
    }
  }
  &__content {
    padding: 2rem 0;
    h2 {
      font-size: 2rem;
      font-weight: bold;
      margin: 2rem 0;
    }
    p {
      margin-bottom: 2rem;
      strong {
        font-weight: bold;
      }
    }
  }
}
</style>
